import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { IGutterAsMarginProps, useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import { SIZES } from '../../fundamentals/sizes/sizes';
import styled from 'styled-components';
import { useTestId } from '../../hooks/useTestId/useTestId';

export type QRCodeSize = typeof SIZES.LARGE | typeof SIZES.X_LARGE | typeof SIZES.XX_LARGE | typeof SIZES.XXX_LARGE | typeof SIZES.MACRO;

export interface IQRCodeProps extends IGutterAsMarginProps {
  url: string;
  size?: QRCodeSize;
  // TODO: we can add a variant to provide svg or canvas version if we need the QRCodeCanvas in the future
}

const QRCodeExtend = styled(
  ({ sizeOfQRCode, gutter, gutterTop, gutterRight, gutterBottom, gutterLeft, ...rest }: IGutterAsMarginProps & { sizeOfQRCode: QRCodeSize; value: string }) => (
    <QRCodeSVG {...rest} />
  )
)`
  height: ${({ theme, sizeOfQRCode }) => `${theme.sizes[sizeOfQRCode]};`};
  width: ${({ theme, sizeOfQRCode }) => `${theme.sizes[sizeOfQRCode]};`};
  ${useGutterAsMarginCss()};
`;

export const QRCode: React.FC<IQRCodeProps> = ({ url, size = SIZES.XXX_LARGE, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'QRCode');
  return <QRCodeExtend value={url} sizeOfQRCode={size} {...rest} {...generateTestId()} />;
};
